import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { BoltFillIcon } from '@/icons';
import { Button } from '@/ui_v3';
export const TryProForFreeBanner = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['common', 'pricing']);
  return <section className="flex flex-col items-center gap-lg bg-gradient-to-b from-violet-400 to-blue-400 px-md py-2xl tablet-sm:px-lg laptop-sm:px-2xl laptop-sm:py-3xl" data-sentry-component="TryProForFreeBanner" data-sentry-source-file="TryProForFreeBanner.tsx">
      <h3 className="whitespace-pre-line text-center text-heading-xl-extrabold text-white">
        {t('pricing:tryProForFree.title')}
      </h3>
      <div className="flex flex-col items-center gap-md">
        <Button intent="alternative" size="lg" rounded="full" leftSlot={<BoltFillIcon size="md" className="fill-strong" />} onClick={() => {
        logger.track('click_try_pro_for_free_button');
        void router.push('/login');
      }} data-sentry-element="Button" data-sentry-source-file="TryProForFreeBanner.tsx">
          {t('pricing:tryProForFree.buttonText')}
        </Button>
        <p className="text-body-md-semibold text-inverse">
          {t('pricing:tryProForFree.notice')}
        </p>
      </div>
    </section>;
};